import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RecipientDetails from '../../../Common/RecipientsDetails/recipient-details.js';
import SwitchwithDetails from '../../../Common/switchwith-details.js';
import GeneralModal from '../../../Common/Modal/GeneralModal/general-modal.js';
import CKeditorpopupData from '../CKEditorpopup/ckeditorpopup-data.js';
import { setDownload } from '../../../../Store/Redux/ckeditor-slice.js';
import CKEditorRecipitensInfo from './ckeditor-recipitens-info.js';

function CKEditorRecipients() {
	const isMobile = useMediaQuery('(max-width:768px)');

	const [showInfo, setShowInfo] = useState(false);
	const [showPopup, setShowPopup] = useState(false);
	const parsedLocation = {};
	const queryParams = new URLSearchParams(window.location.search);

	for (const [key, value] of queryParams.entries()) {
		parsedLocation[key] = value;
	}

	const [selRecipient, setSelRecipient] = useState('');
	const storedRecipients = useSelector(
		(state) => state.recipients.data.recipientsList
	);
	const enableDownload = useSelector((state) => state.ckeditor.enableDownload);

	let currentColorIndex = 0;
	let currentTestColorIndex = 0;

	const [permissons, setPermissons] = useState({
		fordownload: enableDownload,
		suggestededits: '',
		forward: ''
	});
	const [checked, setChecked] = useState(false);

	const [newRecipient, setNewRecipient] = useState({
		name: '',
		email: '',
		mobileno: ''
	});
	const [err, setErr] = useState('');

	const dispatch = useDispatch();

	const theme = useTheme();
	const handleClick = (recipientInfo) => {
		setSelRecipient(recipientInfo);
		setShowInfo(!showInfo);
	};

	const handleAddRecipient = () => {
		setShowPopup(!showPopup);
	};

	const handleNewRecipient = () => {
		validateRecipient(newRecipient);
	};

	useEffect(() => {
		if (permissons) {
			dispatch(setDownload(permissons.fordownload));
		}
	}, [permissons]);

	const validateRecipient = (userdata) => {
		const validationErr = {};

		// Email validation
		const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/;
		if (!userdata.email) {
			validationErr.email = 'Email is required';
		} else if (!emailRegex.test(userdata.email)) {
			validationErr.email = 'Not a valid email';
		} else if (/[A-Z]/.test(userdata.email)) {
			validationErr.email = 'Email cannot contain capital letters';
		} else {
			validationErr.email = '';
		}

		// Name validation
		validationErr.name = userdata.name ? '' : 'Name is required';

		// Mobile number validation
		const phoneRegex = /^[6-9]\d{9}$/;
		if (!userdata.mobileno) {
			validationErr.mobileno = 'Mobile number is required';
		} else if (userdata.mobileno.length > 10) {
			validationErr.mobileno = 'Mobile number should not exceed 10 digits';
		} else if (phoneRegex.test(userdata.mobileno)) {
			validationErr.mobileno = '';
		} else {
			validationErr.mobileno = 'Mobile number is not valid';
		}

		setErr(validationErr);
	};

	const getNextColor = () => {
		const colors = ['#fbfdf0', '#fff9d8', '#fcefed'];
		const nextColor = colors[currentColorIndex];
		currentColorIndex = (currentColorIndex + 1) % colors.length;
		return nextColor;
	};

	const getTextNextColor = () => {
		const colors = ['#D3E966', '#FFDA15', '#E9BC66'];
		const nextColor = colors[currentTestColorIndex];
		currentTestColorIndex = (currentTestColorIndex + 1) % colors.length;
		return nextColor;
	};

	return (
		<>
			{showInfo ? (
				<CKEditorRecipitensInfo
					getNextColor={getNextColor}
					getTextNextColor={getTextNextColor}
					selRecipient={selRecipient}
					showInfo={showInfo}
					setShowInfo={setShowInfo}
					handleClick={handleClick}
				/>
			) : (
				<Box mt={1} pb={4}>
					<GeneralModal
						open={showPopup}
						onClose={handleAddRecipient}
						genText={'Add Recipients'}
						btn2Text={'Add'}
						btn2OnClick={handleNewRecipient}
					>
						<CKeditorpopupData
							data={newRecipient}
							setData={setNewRecipient}
							err={err}
							validateRecipient={validateRecipient}
						/>
					</GeneralModal>
					{parsedLocation.esign === 'true' && storedRecipients?.length > 0 && (
						<>
							<div className={isMobile ? 'semiBold14' : 'semiBold5'}>
								Recipients
							</div>
							<div
								className='medium4 grey-textcolor'
								style={{
									marginTop: isMobile ? theme.spacing(1) : theme.spacing(3),
									marginBottom: theme.spacing(2),
									fontSize: isMobile && 14
								}}
							>
								Current Recipients
							</div>
							<Box mt={2} display={'flex'} flexDirection={'column'} rowGap={2}>
								{storedRecipients.map((el) => (
									<RecipientDetails
										key={el.id}
										recipient={el}
										showRemove={false}
										handleClick={handleClick}
										getNextColor={getNextColor}
										getTextNextColor={getTextNextColor}
									/>
								))}
							</Box>
							{/* <Box
                width={'100%'}
                height={100}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                mt={5}
                sx={{
                  border: '1px dashed #8E8E8E',
                  borderRadius: '8px'
                }}
              >
                <div className='green-circle pointer-css' onClick={handleAddRecipient}>
                  <AddIcon />
                </div>
              </Box>{' '} */}
						</>
					)}
					<Box mt={4}>
						<div className={isMobile ? 'semiBold14' : 'semiBold5'}>
							Permissions
						</div>
						<Box
							display={'flex'}
							mt={isMobile ? 2 : 4}
							flexDirection={'column'}
							rowGap={4}
						>
							<SwitchwithDetails
								text={'Download'}
								subtext='Allow Recipient to download this document'
								checked={checked}
								setChecked={setChecked}
								name={'fordownload'}
								data={permissons}
								setData={setPermissons}
							/>
							{/* <SwitchwithDetails
                text={'Suggest Edits'}
                subtext='Allows recipients to suggest edits to  document'
                checked={checked}
                setChecked={setChecked}
                name={'suggestededits'}
                data={permissons}
                setData={setPermissons}
              />
              <SwitchwithDetails
                text={'Forward'}
                subtext='Allows recipients to forward this document'
                checked={checked}
                setChecked={setChecked}
                name={'forward'}
                data={permissons}
                setData={setPermissons}
              /> */}
						</Box>
					</Box>
				</Box>
			)}
		</>
	);
}

export default CKEditorRecipients;
